import { render } from "./B2bTableMenuProfiles.vue?vue&type=template&id=ab09a8f4&scoped=true&lang=pug"
import script from "./B2bTableMenuProfiles.vue?vue&type=script&lang=js"
export * from "./B2bTableMenuProfiles.vue?vue&type=script&lang=js"

import "./B2bTableMenuProfiles.vue?vue&type=style&index=0&id=ab09a8f4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab09a8f4"]])

export default __exports__